import { FC, useEffect, useState } from "react";
import { Container, HR, PartnersGroup, PartnersGroupTitle } from "./styled";
import { getPartners } from "../../../api/transport/configurationTransport";
import { PartnersGroupsDto, PartnerGroup } from "../../../types/configuration/partners";
import { Loader } from "../../../components/Loader";
import { PartnerElement } from "./PartnerElement";
import { SiteType, TeamContext } from "../../../types/common";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { setDocumentTitle } from "../../../utils";

const GROUP_NAME = {
    club: '',
    league: '',
};

interface PartnersPageProps {
    teamName?: TeamContext;
}

export const PartnersPage: FC<PartnersPageProps> = ({
    teamName,
}) => {
    const config = useConfiguration();
    const [partners, setPartners] = useState<PartnersGroupsDto>();
    const [partnerGroupsNames, setPartnerGroupNames] = useState<Record<PartnerGroup, string>>(GROUP_NAME)
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPartners(config.teamName).then((data) => {
            setPartners(data);
        }).finally(() => {
            setLoading(false);
        });
        if (config.teamName === TeamContext.ACADEMY) {
            setPartnerGroupNames({
                [PartnerGroup.CLUB]: '',
                [PartnerGroup.LEAGUE]: 'Лига',
            })
        }
        setDocumentTitle(`Партнёры - Официальный сайт ${config.site === SiteType.LEGACY_ACADEMY ? "Академия" : "ФК"} «Родина»`);
    }, [config.teamName]);

    if (!partners) {
        return null;
    }

    if (loading) {
        return <Loader />;
    }

    return (
        <Container className="max-w-[1024px] mx-auto">
            <h1 className="py-4 sm:pb-8 text-2xl sm:text-3xl font-semibold text-center text-slate-950">Партнёры</h1>
            {Object.keys(partners).map((group) => {
                const list = partners[group];

                if (!list.length) {
                    return null;
                }

                const title = partnerGroupsNames?.[group] || '';
                return (
                    <PartnersGroup key={group}>
                        {title && <PartnersGroupTitle>{title}</PartnersGroupTitle>}
                        {list.map((partner) => (
                            <>
                                <PartnerElement
                                    key={partner.name}
                                    logo={partner.logo}
                                    name={partner.name}
                                    link={partner.url}
                                    description={partner.description}
                                />
                                <HR />
                            </>
                        ))}
                    </PartnersGroup>
                )
            }
            )}
        </Container>
    );
}